var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3602 1.8549C12.8126 0.715033 11.1861 0.715034 10.6384 1.8549L8.26986 6.78487C8.26986 6.78487 8.26707 6.78867 8.26265 6.78925L2.81303 7.50272C1.55724 7.66713 1.04518 9.21568 1.97288 10.0903L5.95701 13.8466C5.9588 13.8483 5.95864 13.8502 5.95864 13.8502L4.95808 19.2169C4.72462 20.4691 6.04988 21.4152 7.15912 20.8172L11.9937 18.2111C11.9971 18.2093 12.0015 18.2093 12.0049 18.2111L16.8395 20.8172C17.9488 21.4152 19.274 20.4691 19.0406 19.2169L18.04 13.8502C18.04 13.8502 18.0398 13.8483 18.0416 13.8466L22.0258 10.0903C22.9535 9.21568 22.4414 7.66713 21.1856 7.50272L15.736 6.78925C15.7316 6.78867 15.7288 6.78487 15.7288 6.78487L13.3602 1.8549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.863e25ed14ff15e1c2847d596f9c343e.svg";
export { ForwardRef as ReactComponent };